import messages from "@smartmixin/i18n/dist/translations/da.json";

export default messages;
